import { AdFormConfig } from '@ads/types/AdForm';

export default {
  // All available adForm types
  types: [
    'siteheader',
    'mobilesiteheader',
    'content',
    'tower',
    'gallerytower',
    'mobile',
    'floating',
    'scroller',
    'floor',
    'teaser',
    'interstitial',
    'mobileinterstitial',
    'leaderboard',
    'square',
    'mobileleaderboard',
    'galleryscroller',
    'bottom',
  ],
  // These ads are disabled for subscribers
  disableAds: [
    'siteheader',
    'mobilesiteheader',
    'floating',
    'scroller',
    'interstitial',
    'mobileinterstitial',
    'leaderboard',
    'mobileleaderboard',
    'galleryscroller',
  ],

  mobileAds: ['mobile', 'mobilesiteheader', 'mobileinterstitial', 'scroller', 'galleryscroller'],
  // Replaces desktop ads with mobile ads
  mobileFallbackAds: {
    square: 'mobile',
    content: 'mobile',
    siteheader: 'mobilesiteheader',
    floating: 'scroller',
    interstitial: 'mobileinterstitial',
    teaser: 'teaser',
    leaderboard: 'mobileleaderboard',
  },
} as AdFormConfig;
